module.exports = __webpack_public_path__ + "static/media/Document4.57626b6e.png";